import React, { useState, ChangeEvent, FC } from 'react';
import { withRouter } from 'react-router-dom';
import '../assets/css/geral.scss';
import { Button } from 'react-bootstrap';

// Modal component for editing sections
const SectionModal: FC<{ sections: string[], onSave: (updatedSections: string[]) => void, onClose: () => void }> = ({ sections, onSave, onClose }) => {
  const [localSections, setLocalSections] = useState<string[]>([...sections]);

  const handleSectionChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    const prefix = getPrefix(localSections[index]);
    const newSections = [...localSections];
    newSections[index] = `${prefix}${e.target.value}`;
    setLocalSections(newSections);
  };


  const handleSave = () => {
    onSave(localSections);
  };

  const getPrefix = (section: string) => {
    if (section.startsWith("BOTTOM")) return "BOTTOM ";
    if (section.startsWith("LEFT")) return "LEFT ";
    return "";
  };

  const getSuffix = (section: string) => {
    const prefix = getPrefix(section);
    return section.substring(prefix.length);
  };

  return (
    <div className="modal-section">
      <div className="modal-section-content">
        <h2>Edit Sections</h2>
        {localSections.map((section, index) => {
          const prefix = getPrefix(section);
          const suffix = getSuffix(section);
          return (<div key={index}>
            <span>{prefix}</span>
            <input
              type="text"
              className='wid80 mb-2'
              value={suffix}
              onChange={(e) => handleSectionChange(e, index)}
            />
          </div>);
        })}
        <Button className='mr-2 mt-3' onClick={handleSave}>Save</Button>
        <Button className="mt-3" onClick={onClose}>Close</Button>
      </div>
    </div>
  );
};

// Main modal component that wraps SectionModal
export const SectionEditModal: FC<{ sections: string[], onSave: (updatedSections: string[]) => void, onClose: () => void }> = ({ sections, onSave, onClose }) => {
    {console.log("here")}
  return (
    <SectionModal sections={sections} onSave={onSave} onClose={onClose} />
  );
};

//export default withRouter(SectionEditModal);
